// extracted by mini-css-extract-plugin
export var bodyRow = "_f2-d";
export var cardColumns = "_f2-e";
export var ellipsesOverflow = "_f2-2";
export var flatBottomCorners = "_f2-3";
export var flatTopCorners = "_f2-4";
export var headerActionsDropdown = "_f2-f";
export var headerBottomRow = "_f2-c";
export var headerTopRow = "_f2-b";
export var orderDetailsWrapper = "_f2-0";
export var orderInfoContainer = "_f2-1";
export var productDetails = "_f2-9";
export var productImage = "_f2-5";
export var responsiveTable = "_f2-8";
export var shipmentContainer = "_f2-a";
export var tableBottomLeft = "_f2-6";
export var tableBottomRight = "_f2-7";
export var trackingLink = "_f2-g";